<template>
    <CCard id="ga-track-ZoneAttributes">
        <CCardBody>
            <div class="DivInline">
                <div class="title" style="margin-bottom: 5px">商圈綜合指標</div>
                <div class="mt-1">
                    <svg-img-icons v-c-tooltip="'<div class=text-left>商圈屬性強度，依低至高分為0~5級​</div>'"
                                   height="20"
                                   name="question"
                                   width="22" />
                </div>
            </div>
            <div :class="{'blur-style': lockedReport}">
                <CRow>
                    <CCol>
                        <div class="row b-block ">
                            <div class=" col"><span style="font-size:1.1rem;color:#888;margin:0px">商圈屬性</span></div>
                            <div class="b-block-cont col-8"><p><span> {{ businessAttribute }}</span></p></div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol>
                        <polar-area-chart :chart-data="chartData" :options="chartOptions" ref="polarareachartref" style=" height:360px;display: block; margin: 0 auto;"></polar-area-chart>
                    </CCol>
                </CRow>
            </div>
        </CCardBody>
    </CCard>
  
</template>


<script>
import PolarAreaChart from '../components/DisplayTemplate/vue-chartjs/PolarAreaChart'
import { mapState } from 'vuex';

export default {
  name: 'ComprehensiveIndicators',
  components: {
    PolarAreaChart
  },
  data: function () {
    return {
      businessAttribute: "",
      chartData: {},
      chartOptions: {},
    }
  },
  computed: {
    ...mapState({
        lockedReport: (state) => state.lockedReport
    })
  },
  methods: {
      setData(comprehensiveIndicatorsData) { 
      if (comprehensiveIndicatorsData !== undefined) {
        var attributes = (comprehensiveIndicatorsData.Attributes === undefined) ? "" : comprehensiveIndicatorsData.Attributes.join();
        this.businessAttribute = attributes;
        this.updateChart(comprehensiveIndicatorsData);
      }


    },
    updateChart(data) {

      this.chartData = {
        labels: ['住宅', '商業', '旅遊', '文教', '休閒娛樂'],
        datasets: [
          {
 
            backgroundColor: [
              'rgba(136, 136, 136,0.6)',
              'rgba(251, 146, 36,0.6)',
              'rgba(237, 197, 49,0.6)',
              'rgba(137, 101, 0,0.6)',
              'rgba(100, 163, 111,0.6)'
            ],
            data: [
              data.Residential,
              data.Business,
              data.Tourism,
              data.Educational,
              data.Leisure
            ]
            /* [1, 2, 3, 4, 5]   */
          }
        ]
      }

      this.chartOptions = {
        responsive: true, 
        maintainAspectRatio: false,
        scale: {
          ticks: {
            min: 0,
            max: 5,
            stepSize: 1,
            fontSize: 13, 
            fontColor: '#000'
          }
        },
        legend: {
           fontFamily:'微軟正黑體',
           fontSize: '14px', 
           color: '#dfsda',
           floating: false,  
           fontStyle: "bold", 
           labels: {
            usePointStyle: true,
           },
           position: 'bottom'
        }
      }
    }
  },
}
</script> 

 

